import { Box, Stack, Typography } from '@mui/material'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import {
  availableAreaUrl,
  baseURL,
  deviceCampaignLabel,
  deviceCampaignPriceNumber,
  devicePriceNote,
  devicePriceNumber,
  isStaging,
  serviceName,
} from 'src/config'

// TODO Helmet
export const Tokai0001 = () => {
  return (
    <>
      <Helmet>
        {isStaging && <meta name="robots" content="noindex" />}
        <meta charSet="utf-8" />
        <title>{serviceName} | IoT罠(LTEモデル)のご紹介</title>
        <meta property="og:type" content="product" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content={`${serviceName} | IoT罠(LTEモデル)のご紹介 低価格・使いやすい・単三電池で長時間稼働と3拍子揃ったモデルです 電波はLTE-M回線(スマホ)等と同じを利用します`}
        />
        <meta
          property="description"
          content={`${serviceName} | IoT罠(LTEモデル)のご紹介 低価格・使いやすい・単三電池で長時間稼働と3拍子揃ったモデルです 電波はLTE-M回線(スマホ)等と同じを利用します`}
        />
        <meta property="og:url" content={`${baseURL}/deviceTypes/lte-model-0001`} />
        {/* SNS */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={serviceName} />
        <meta
          name="twitter:description"
          content={`${serviceName} | IoT罠(LTEモデル)のご紹介 低価格・使いやすい・単三電池で長時間稼働と3拍子揃ったモデルです 電波はLTE-M回線(スマホ)等と同じを利用します`}
        />
      </Helmet>
      <Stack spacing={2}>
        <Typography variant="h5">LTEモデル - 商品紹介ページ</Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: (theme) => theme.palette.grey[300],
          }}
        >
          <img src="/wanapp_device_image.png" height="280px" alt="デバイスのイメージ" />
        </Box>
        <Typography variant="h6">機能</Typography>
        <Typography>
          くくり罠や箱罠にデバイスを併設することでご利用いただけます。
          <br />
          LTE-M回線(スマートフォン)等と同じ仕組みでインターネットに接続します。圏外ではご使用いただけないため、比較的人里に近い場所での利用を想定しています。
          <br />
          利用可能エリアは
          <Link to={availableAreaUrl} target="_blank">
            こちら
          </Link>
          よりご確認ください。
          <br />
          <br />
          通知はデバイスの電源on、罠の作動、故障や電池切れの可能性の検知の3種類があります。
          <br />
          現在通知方法はメールとLINE、管理画面への通知に対応しています。
          <br />
          必要最低限の機能のみ実装しているため、使いやすくお求め易い価格となっております。
          <br />
          <br />
          動力は単3電池3本で約3〜4ヶ月稼働します (気候や電波の状態で上下します)。
          <br />
          <br />
          本体寸法は 幅100 × 高さ150 × 奥行70 mm です。
        </Typography>
        <Typography variant="h6">料金</Typography>
        <Typography>
          デバイス本体価格 定価{devicePriceNumber}円 → {deviceCampaignLabel}価格 {deviceCampaignPriceNumber}円 (税込)
          <br />
          <br />
          {devicePriceNote}
          <br />
          ※毎月の通信費はかかりません。約10年分の通信費が本体価格に含まれています。
          <br />
          ※概算10年間利用できます。
          <br />
          ※通信上限に達した場合有料(4,000円)で追加で通信できます。 (追加分も同様概算10年間利用できます)
        </Typography>
        {/* TODO link to 申し込みページ */}
      </Stack>
    </>
  )
}
